import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { AlgoStrategyLookupService } from "../../lookup/model/impl/AlgoStrategyLookupService";
import { BfxSysConfigUtilService } from "shared/auth-services";
import { ScratchPadOrder } from "./ScratchPadOrder";

export class OrderTypeHelper {
  // This is only valid for CubiqTS.OrderData
  protected columnProperty = "requestedOrderType";

  constructor(
    protected _partFillDisabledTypeText,
    protected _algoStrategyLookup: AlgoStrategyLookupService,
    protected sysConfigUtil?: BfxSysConfigUtilService,
    _columnProperty = "requestedOrderType",
  ) {
    this.columnProperty = _columnProperty;
  }

  getType(row: CubiqTS.OrderDataImpl): string {
    return this.retrieveSearch(row);
  }

  getInvertType(row: CubiqTS.OrderDataImpl): string {
    return this.retrieveInvertSearch(row);
  }

  /**
   *
   * @param order Get type that corresponds to one of list of filtereable values. This currently
   * flattens all TP labels to TP(removing  TP (AON)), MKT labels to MKT(removing  MKT(AON)),SL Bid/Asks to SL,
   * and TSL Bid/Asks to TSL
   *
   * @param inverted
   * @returns
   */
  getFilterOrderType(order: CubiqTS.OrderDataImpl | CubiqTS.DealImpl): string {
    const orderType =
      order instanceof CubiqTS.OrderDataImpl ? order.requestedOrderType : order.requestOrderType;
    switch (orderType) {
      case CubiqTS.RequestOrderType.TP:
        return "TP";
      case CubiqTS.RequestOrderType.SL_BID:
      case CubiqTS.RequestOrderType.SL_ASK:
      case CubiqTS.RequestOrderType.SL_ATRATE:
        return "SL";
      case CubiqTS.RequestOrderType.CALL:
        return "CALL";
      case CubiqTS.RequestOrderType.TSL:
      case CubiqTS.RequestOrderType.TSL_BID:
      case CubiqTS.RequestOrderType.TSL_ASK:
        return "TSL";
      case CubiqTS.RequestOrderType.MARKET:
        return "MKT";
      case CubiqTS.RequestOrderType.ALGO:
      case CubiqTS.RequestOrderType.BMALGO: {
        let algoStrategyDescription = this.getAlgoStrategyDescription(order);

        if (algoStrategyDescription !== null) {
          return algoStrategyDescription;
        }
        return order.algoStrategyName;
      }
      case CubiqTS.RequestOrderType.BMARK: {
        let isPositionOrder =
          order instanceof CubiqTS.OrderDataImpl &&
          CubiqTS.BenchmarkOrderType.PositionOrder === order.fixingDetails?.bmOrderType;
        return isPositionOrder ? "BMHO" : "BMARK";
      }
      default:
        break;
    }
    return CubiqTS.RequestOrderType[orderType];
  }

  retrieveData(order: CubiqTS.OrderDataImpl, columnProperty: string, html: boolean = true): string {
    const orderType: any = order[this.columnProperty];
    if (orderType != undefined && orderType != null) {
      let retStr: string = this.retrieveSearch(order);

      if (
        (html &&
          (CubiqTS.RequestOrderType.SL_ASK === orderType ||
            CubiqTS.RequestOrderType.SL_ATRATE === orderType ||
            CubiqTS.RequestOrderType.SL_BID === orderType ||
            CubiqTS.RequestOrderType.TSL === orderType ||
            CubiqTS.RequestOrderType.TSL_ASK === orderType ||
            CubiqTS.RequestOrderType.TSL_BID === orderType)) ||
        (CubiqTS.RequestOrderType.ALGO == orderType &&
          CubiqTS.OrderType.LIMIT_SL == order.monitoringOrderType)
      ) {
        retStr = '<span class="order-type order-type-sl">' + retStr + "</span>";
      }

      return retStr;
    }

    return "-";
  }

  protected getInvertValue(order: any, isPositionOrder: boolean): string {
    let requestedOrderType = order[this.columnProperty];
    let { executionType } = order;
    switch (requestedOrderType) {
      case CubiqTS.RequestOrderType.BMARK:
        return isPositionOrder ? "BMHO" : "BMARK";
      case CubiqTS.RequestOrderType.CALL:
        return executionType == CubiqTS.ExecutionType.MANUAL
          ? this.sysConfigUtil.manualExecutionCallNameText
          : "CALL";
      case CubiqTS.RequestOrderType.SL_ASK:
        return "SL BID";
      case CubiqTS.RequestOrderType.SL_ATRATE:
        return "SL";
      case CubiqTS.RequestOrderType.SL_BID:
        return "SL ASK";
      case CubiqTS.RequestOrderType.TP:
        return "TP";
      case CubiqTS.RequestOrderType.TSL_ASK:
        return "TSL BID";
      case CubiqTS.RequestOrderType.TSL:
        return "TSL";
      case CubiqTS.RequestOrderType.TSL_BID:
        return "TSL ASK";
      case CubiqTS.RequestOrderType.MARKET:
        return "MKT";
    }
    return CubiqTS.RequestOrderType[requestedOrderType];
  }

  public getValue(order: any, isPositionOrder: boolean): string {
    let requestedOrderType = order[this.columnProperty];
    let { executionType } = order;
    switch (requestedOrderType) {
      case CubiqTS.RequestOrderType.BMARK:
        return isPositionOrder ? "BMHO" : "BMARK";
      case CubiqTS.RequestOrderType.CALL:
        return executionType == CubiqTS.ExecutionType.MANUAL
          ? this.sysConfigUtil.manualExecutionCallNameText
          : "CALL";
      case CubiqTS.RequestOrderType.SL_ASK:
        return "SL ASK";
      case CubiqTS.RequestOrderType.SL_ATRATE:
        return "SL";
      case CubiqTS.RequestOrderType.SL_BID:
        return "SL BID";
      case CubiqTS.RequestOrderType.TP:
        return "TP";
      case CubiqTS.RequestOrderType.TSL_ASK:
        return "TSL ASK";
      case CubiqTS.RequestOrderType.TSL:
        return "TSL";
      case CubiqTS.RequestOrderType.TSL_BID:
        return "TSL BID";
      case CubiqTS.RequestOrderType.MARKET:
        return "MKT";
    }
    return CubiqTS.RequestOrderType[requestedOrderType];
  }

  public getColumnProperty(): string {
    return this.columnProperty;
  }

  retrieveSort(order: any): string {
    return this.retrieveSearch(order);
  }

  retrieveSearch(order: CubiqTS.OrderDataImpl | CubiqTS.DealImpl): string {
    let retStr;

    if (
      (CubiqTS.RequestOrderType.ALGO === order[this.columnProperty] ||
        CubiqTS.RequestOrderType.BMALGO === order[this.columnProperty]) &&
      typeof order.algoStrategyName === "string"
    ) {
      let algoStrategyDescription = this.getAlgoStrategyDescription(order);

      if (algoStrategyDescription !== null) {
        return algoStrategyDescription;
      }

      return order.algoStrategyName;
    } else {
      let posType: CubiqTS.BenchmarkOrderType = CubiqTS.BenchmarkOrderType.PositionOrder;
      let isPositionOrder =
        CubiqTS.RequestOrderType.BMARK === order[this.columnProperty] &&
        ((order["fixingDetails"] != null && posType === order["fixingDetails"].bmOrderType) ||
          posType === order["benchmarkOrderType"]);
      retStr = this.getValue(order, isPositionOrder);
    }

    if (
      CubiqTS.FillSupport.ALL_OR_NOTHING === (order as CubiqTS.OrderData).executionInstruction &&
      this._partFillDisabledTypeText &&
      (order as CubiqTS.OrderData).orderType != CubiqTS.OrderType.BENCHMARK
    ) {
      return `${retStr} ${this._partFillDisabledTypeText}`;
    }

    return retStr;
  }

  retrieveInvertSearch(order: CubiqTS.OrderDataImpl): string {
    let retStr;

    if (
      (CubiqTS.RequestOrderType.ALGO === order[this.columnProperty] ||
        CubiqTS.RequestOrderType.BMALGO === order[this.columnProperty]) &&
      typeof order.algoStrategyName === "string"
    ) {
      let algoStrategyDescription = this.getAlgoStrategyDescription(order);

      if (algoStrategyDescription !== null) {
        return algoStrategyDescription;
      }

      return order.algoStrategyName;
    } else {
      let isPositionOrder =
        CubiqTS.RequestOrderType.BMARK === order.requestedOrderType &&
        order.fixingDetails != null &&
        CubiqTS.BenchmarkOrderType.PositionOrder === order.fixingDetails.bmOrderType;

      retStr = this.getInvertValue(order, isPositionOrder);
    }

    if (
      CubiqTS.FillSupport.ALL_OR_NOTHING === (order as CubiqTS.OrderData).executionInstruction &&
      this._partFillDisabledTypeText &&
      (order as CubiqTS.OrderData).orderType != CubiqTS.OrderType.BENCHMARK
    ) {
      return `${retStr} ${this._partFillDisabledTypeText}`;
    }

    return retStr;
  }

  retrieveFilter(order: any): string {
    let ret = CubiqTS.RequestOrderType[order[this.columnProperty]];

    if (
      (CubiqTS.RequestOrderType.ALGO === order.requestedOrderType ||
        CubiqTS.RequestOrderType.BMALGO === order.requestedOrderType) &&
      typeof order.algoStrategyName === "string"
    ) {
      ret = order.algoStrategyName;
    } else if (
      CubiqTS.OrderType.MARKET === order.orderType ||
      CubiqTS.OrderType.MARKET_IOC === order.orderType ||
      CubiqTS.OrderType.MARKET_FOK === order.orderType
    ) {
      ret = CubiqTS.RequestOrderType[CubiqTS.RequestOrderType.MARKET];
    }
    return ret;
  }

  getAlgoStrategyDescription(order: any) {
    let algoStrategyName = order.algoStrategyName;

    if (this._algoStrategyLookup.hasAlgoStrategy(algoStrategyName)) {
      let algoStrategy = this._algoStrategyLookup.getAlgoStrategy(algoStrategyName);

      if (algoStrategy && typeof algoStrategy.description === "string")
        return algoStrategy.description;
    }

    return null;
  }

  public static isStop(requestOrderType: CubiqTS.RequestOrderType): boolean {
    switch (requestOrderType) {
      case CubiqTS.RequestOrderType.SL_ASK:
      case CubiqTS.RequestOrderType.SL_ATRATE:
      case CubiqTS.RequestOrderType.SL_BID:
      case CubiqTS.RequestOrderType.TSL:
      case CubiqTS.RequestOrderType.TSL_ASK:
      case CubiqTS.RequestOrderType.TSL_BID:
        return true;
      default:
        return false;
    }
  }

  public static canSTPAggregate(orderData: CubiqTS.OrderDataImpl): boolean {
    return (
      OrderTypeHelper.isStop(orderData.requestedOrderType) ||
      (orderData.requestedOrderType === CubiqTS.RequestOrderType.TP &&
        orderData.executionInstruction === CubiqTS.FillSupport.ALLOW_PARTIAL)
    );
  }
  public static canSTPAggregateScratchPadOrder(orderData: ScratchPadOrder): boolean {
    return (
      OrderTypeHelper.isStop(orderData.requestOrderType) ||
      (orderData.requestOrderType === CubiqTS.RequestOrderType.TP &&
        orderData.fillSupport === CubiqTS.FillSupport.ALLOW_PARTIAL)
    );
  }
}
